import * as React from "react"

export default function GatsbyContentfulLogo({color}) {
  const colorToShow = color || '#000000';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="127"
      height="32"
      version="1.1"
      viewBox="0 0 33.602 8.467"
      xmlSpace="preserve"
    >
      <g transform="translate(-9.145 -11.224)">
        <g
          fill={colorToShow}
          fillRule="evenodd"
          clipRule="evenodd"
          transform="matrix(.26458 0 0 .26458 9.145 11.224)"
        >
          <path d="M40.594 6.549c.078-1.171-.855-2.54-.855-2.54s1.998-1.607 1.833-1.864c-.82-.6-3.059.97-4.011.253-.634-.477-1.033-.665-1.222-.76-.054-.028-.122-.087 0-.123.28-.08.909.217.909.217-.614-.606-1.484-1.217-3.583-1.123 0 0-.174.041-.134-.067.16-.244.899-.336.899-.336s-4.274-.792-8.368.73C19.586 3.346 15.49 7.45 15.49 7.45 6.237 5.483 4.42 10.7 3.124 13.322 1.576 16.455 0 16.812 0 16.812s.044 1.944 2.883 1.586c1.962-.248 3.447-2.3 4.243-3.414 1.238-1.73 3.021-3.659 3.021-3.659 1.521-1.538 3.992-1.969 4.36-1.132-.198.328-1.376 2.44-.477 4.637 0 0 .601 1.41-1.284 3.855-.607.648-.798.786-.801 2.006-.002.804-.063 3.214-.124 3.647-.146 1.032-.488 1.447-.067 1.69.421.244 1.631.087 1.653-1.348 0 0 .219-4.002.345-4.513.216-.872 1.79-1.727 2.484-3.225-.252 1.53-1.923 2.423-2.017 3.37-.083.836-.252 3.739-.252 3.739-.032.988-.379 1.403-.032 1.69.257.36 1.544.095 1.576-1.116 0 0 .188-2.935.19-2.997.03-1.785 1.732-2.391 2.347-2.738 1.619-.914 2.927-2.823 3.25-5.156 0 0-.036-.364.503-.691 0 0 2.246-1.694 4.835-3.032 2.854-1.475 4.231-1.536 5.894-1.235 1.025.187 1.577 1.056 2.893 2.687 1.6 1.986 2.728.675 2.547.271-.055-.123-.492-.42-.759-.643-.447-.373-1.077-1.222-1.077-1.222s-.895-1.545-1.58-2.236c-.655-.664-1.935-.633-2.8-.618-1.689.03-2.12-.478-2.12-.478.61.073 1.74.206 3.29.005.862-.112 1.472.13 2.052.691.605.586 1.32 1.986 1.32 1.986s1.268-.225 2.308.544c.91.672 1.848.673 2.257.583.544-.167.816-.57.821-.612.005-.042-.935-.999-1.028-1.113-.649-.793-.138-.901-.06-2.072"></path>
       </g>
      </g>
    </svg>
  )
}
